window.InifECShared.factory("UserService", ['$q', '$http', '$timeout', '$rootScope', '$FB', 'Upload', 'ShoppingCartService', 'BusinessMemberService',
    function($q, $http, $timeout, $rootScope, $FB, Upload, ShoppingCartService, BusinessMemberService) {

    	var factory = this;
        var user = {
            mrscid: undefined, // 使用者id
            email: "", // 使用者電子郵件
            name: "", // 使用者顯示名稱
            descript: "", // 使用者介紹
            memberphotoUrl: "", // 顯示大頭照網址
            phone: "", // 使用者電話
            mobilephone: "", // 使用者手機
            address: "", // 使用者地址
            postal: "", // 使用者郵遞區號
            company: "", // 使用者公司
            invoice: "", // 使用者統編
            fax: "", // 傳真號碼
            phoneExtension: "", // 分機
            contactInfo: undefined, // 最後使用地址
            isNoPassword: false,
            lastInvoiceInfo: [],
            membertype: 0, // 0 一般會員 1 企業用戶
        };
        var hasLogin = false;

        // --------------------------------
        // 初始化，一進入就取得使用者資訊
        // --------------------------------
        var init = function() {
            getUserInfo();
        }

        // --------------------------------
        // 取得使用者資訊
        // --------------------------------
        var getUserInfo = function(skipCache) {

            if(factory.defer && !skipCache){
                return factory.defer.promise;
            }

            factory.defer = $q.defer();
            
            $http({
                url: SECURE_INIFEC_URL + "/MemberAction.do",
                method: "GET",
                params: {
                    op: "qySelfProfile"
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {
                    factory.defer.reject(data.error);
                } else {

                    // 為企業用戶要另外拿資料
                    if(data.membertype && data.membertype == 1) {

                        BusinessMemberService.getSelfProfile(skipCache).then(function(result) {
                            if(result) {
                                setLoginUserInfo(data);
                                // 合併企業用戶資訊
                                $.extend(factory.user, result);
                                factory.defer.resolve(factory.user);
                            } else {
                                factory.defer.reject(true);
                            }
                        }, function(error) {
                            factory.defer.reject(error);
                        });
                    } else {
                        setLoginUserInfo(data);

                        factory.defer.resolve(factory.user);
                    }
                }
            }).error(function(data, status, headers, config) {
                factory.defer.reject(data);
                console.error("[InifEC Error] : UserFactory.getUserInfo request error.");
                console.error("status : " + status);
            });

            return factory.defer.promise;
        }

        var getJoinMemberCarrierParam = function() {
            var defer = $q.defer();
            $http({
                url: SECURE_INIFEC_URL + "/MemberAction.do",
                method: "GET",
                params: {
                    op: "joinMemberCarrier"
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {
                    defer.reject(data.error);
                } else {
                    defer.resolve(data);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[Jcolor Error] : UserFactory.getUserInfo request error.");
                console.error("status : " + status);
            });

            return defer.promise;
        }

        // --------------------------------
        // [private] 設定會員資訊
        // --------------------------------
        var setLoginUserInfo = function(userinfo) {

            userinfo.phone = removeDashInNumber(userinfo.phone);
            userinfo.mobilephone = removeDashInNumber(userinfo.mobilephone);

            factory.hasLogin = true;
            factory.user.email = userinfo.email;
            factory.user.name = userinfo.name;
            factory.user.mrscid = userinfo.mrscid;
            factory.user.descript = userinfo.description || '';
            factory.user.phone = userinfo.phone || '';
            factory.user.mobilephone = userinfo.mobilephone || '';
            factory.user.address = userinfo.address || '';
            factory.user.postal = userinfo.postal || '';
            factory.user.company = userinfo.company || '';
            factory.user.invoice = userinfo.invoice || '';
            factory.user.fax = userinfo.fax || '';
            factory.user.phoneExtension = userinfo.phoneExtension || '';
            factory.user.isNoPassword = userinfo.isNoPassword;
            factory.user.contactInfo = userinfo.contactInfo;
            factory.user.lastInvoiceInfo = userinfo.lastInvoiceInfo || [];
            factory.user.membertype = userinfo.membertype || 0;
            factory.user.memberphotoUrl = userinfo.profImageUrl;

            // 一般會員沒圖就用defult圖
            if(!factory.user.memberphotoUrl && factory.user.membertype == 0) {
                factory.user.memberphotoUrl = 'images/dummy/dummy_member_150.png';
            }
        }

        // --------------------------------
        // 申請成為會員
        // --------------------------------
        var applyAccount = function(email, passwd, name, mobilephone, phone, address, postal, phoneExtension, company, invoice) {

            var defer = $q.defer();

            phone = removeDashInNumber(phone);
            mobilephone = removeDashInNumber(mobilephone);
            
            $http({
                url:  SECURE_INIFEC_URL + "/MemberAction.do",
                method: "POST",
                data: $.param({
                    op: "register",
                    email: email,
                    passwd: passwd,
                    membername: name,
                    mobilephone: mobilephone,
                    phone: phone,
                    address: address,
                    postal: postal,
                    phoneExtension: phoneExtension,
                    company: company,
                    invoice: invoice,
                    createfrommobile: window.isMobile || window.location.protocol == "file:",
                }),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {
                    defer.reject(data.error);
                } else {
                    defer.resolve(true);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : UserFactory.applyAccount request error.");
                console.error("status : " + status);
            });

            return defer.promise;
        }

        // ------------------------------
        // Email 認證
        // ------------------------------
        var identifyEmail = function(token) {

            var defer = $q.defer();

            $http({
                url: SECURE_INIFEC_URL + "/MemberAction.do",
                method: "POST",
                params: {
                    op: "finishApply",
                    token: token
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {
                    defer.reject(data.error);
                } else {
                    defer.resolve(data);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : UserFactory.identifyEmail request error.");
                console.error("status : " + status);
            });

            return defer.promise;

        }

        // --------------------------------
        // 以EMail登入
        // --------------------------------
        var loginWithEmail = function(email, password) {

            var defer = $q.defer();
            
            $http({
                url: SECURE_INIFEC_URL + "/MemberAction.do",
                method: "POST",
                data: $.param({
                    op: "login",
                    email: email,
                    passwd: password,
                }),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {
                    defer.reject(data.error);
                } else {
                    // udate
                    factory.defer = undefined;
                    getUserInfo();

                    defer.resolve(true);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : UserFactory.loginWithEmail request error.");
                console.error("status : " + status);
            });

            return defer.promise;
        }

        // --------------------------------
        // 登出
        // --------------------------------
        var logout = function() {

            var defer = $q.defer();

            $http({
                url: SECURE_INIFEC_URL + "/MemberAction.do",
                method: "GET",
                params: {
                    op: "logout"
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {
                    defer.reject(data.error);
                } else {
                    // reset
                    factory.defer = undefined;
                    factory.hasLogin = false;
                    factory.user.mrscid = undefined;
                    factory.user.email = "";
                    factory.user.name = "";
                    factory.user.id = "";
                    factory.user.phone = "";
                    factory.user.mobilephone = "";
                    factory.user.descript = "";
                    factory.user.memberphotoUrl = "";
				    factory.user.address = "";
				    factory.user.postal = "";
				    factory.user.company = "";
				    factory.user.invoice = "";
				    factory.user.fax = "";
                    factory.user.phoneExtension = "";
                    factory.user.contactInfo = undefined;
                    factory.user.lastInvoiceInfo = [];

                    ShoppingCartService.logutResetCart();
                    BusinessMemberService.logutResetInfo();

                    defer.resolve(true);
                }
            }).error(function(data, status, headers, config) {
                factory.defer.reject(data);
                console.error("[InifEC Error] : UserFactory.logout request error.");
                console.error("status : " + status);
            });

            return defer.promise;
        }

        // --------------------------------
        // 忘記密碼
        // --------------------------------
        var forgetPassword = function(email) {

            var defer = $q.defer();

            $http({
                url: SECURE_INIFEC_URL + "/MemberAction.do",
                method: "POST",
                data: $.param({
                    op: "forgotPassword",
                    email: email
                }),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {
                    defer.reject(data.error);
                } else {
                    defer.resolve(true);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : UserFactory.forgetPassword request error.");
                console.error("status : " + status);
            });

            return defer.promise;
        }

        // ------------------------------
        // 更新密碼
        // 1. 忘記密碼的話 要傳email token 和 新密碼
        // 2. 如果是單純更改密碼，只要傳新密碼 和token 而token是舊密碼
        // ------------------------------
        var updPassword = function(token, passwd, email) {

            var defer = $q.defer();

            $http({
                url:  SECURE_INIFEC_URL + "/MemberAction.do",
                method: "POST",
                data: $.param({
                    op: "updatePassword",
                    confirmkey: token,
                    passwd: passwd,
                    email: email,
                }),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {
                    defer.reject(data.error);
                } else {
                    defer.resolve(data);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : UserFactory.updPassword request error.");
                console.error("status : " + status);
            });

            return defer.promise;
        }

        // ------------------------------
        // 重寄認證信
        // ------------------------------
        var resendInvitaion = function(email) {

            var defer = $q.defer();

            $http({
                url: SECURE_INIFEC_URL + "/MemberAction.do",
                method: "POST",
                data: $.param({
                    op: "resendInvitation",
                    email: email,
                }),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {
                    defer.reject(data.error);
                } else {
                    defer.resolve(data);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : UserFactory.resendInvitaion request error.");
                console.error("status : " + status);
            });

            return defer.promise;
        }

        // ------------------------------
        // 更新使用者資訊
        // ------------------------------
        var updateUserInfo = function(member){
            var defer = $q.defer();

            member.phone = removeDashInNumber(member.phone);
            member.mobilephone = removeDashInNumber(member.mobilephone);            

            $http({
                url: SECURE_INIFEC_URL + "/MemberAction.do",
                method: "POST",
                data: $.param({
                    op: "updateMemberInfo",
                    mrscid: member.mrscid,
                    membername: member.name,
                    phone: member.phone,
                    mobilephone: member.mobilephone,
                    description: member.descript,
                    address: member.address,
                    postal: member.postal,
                    company: member.company,
                    invoice: member.invoice,
                    fax: member.fax,
                    phoneExtension: member.phoneExtension,
                    invoiceType: member.invoiceType,
                    carrierType: member.carrierType,
                    digitalCitizenCarrierID: member.digitalCitizenCarrierID,
                    mobilePhoneCarrierID: member.mobilePhoneCarrierID,
                    donate: member.isDonate,
                    loveCode: member.loveCode,

                }),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {

                    if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                        $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                    }

                    defer.reject(data.error);
                }else{
                    // update info
                    factory.user.name = member.name;
                    factory.user.phone = member.phone;
                    factory.user.mobilephone = member.mobilephone;
                    factory.user.descript = member.descript;
                    factory.user.address = member.address;
                    factory.user.postal = member.postal;
                    factory.user.company = member.company;
                    factory.user.invoice = member.invoice;
                    factory.user.fax = member.fax;
                    factory.user.phoneExtension = member.phoneExtension;
                    defer.resolve(true);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : UserFactory.updateUserInfo request error.");
                console.error("status : " + status);
            });

            return defer.promise;
        }

        // ------------------------------
        // 修改使用者電子郵件
        // ------------------------------
        var updateEmail = function(pendingemail) {
            var defer = $q.defer();

            $http({
                url: SECURE_INIFEC_URL + "/MemberAction.do",
                method: "POST",
                data: $.param({
                    op: "updateMemberEmail",
                    pendingemail: pendingemail
                }),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if(data.error){

                    if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                        $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                    }

                    defer.reject(data.error);
                }else{
                    defer.resolve(data);
                }
            }).error(function(data, status, headers, config){
                defer.reject(data);
                console.error("[InifEC Error] : UserFactory.updateEmail request error.");
                console.error("status : " + status);
            });

            return defer.promise;
        }

        // --------------------------------
        // 設定新的電子郵件
        // --------------------------------
        var changeEmail = function(mrscid, confirmkey) {
            var defer = $q.defer();

            $http({
                url: SECURE_INIFEC_URL + "/MemberAction.do",
                method: "POST",
                data: $.param({
                    op: "confirmUpdateMemberEmail",
                    mrscid: mrscid,
                    confirmkey: confirmkey
                }),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if(data.error){
                    defer.reject(data.error);
                }else{
                    defer.resolve(data);
                }
            }).error(function(data, status, headers, config){
                defer.reject(data);
                console.error("[InifEC Error] : UserFactory.changeEmail request error.");
                console.error("status : " + status);
            });

            return defer.promise;
        }

        // --------------------------------
        // 更新使用者大頭照
        // --------------------------------
        var updMemberPhoto = function(file, cropX, cropY, cropWidth, cropHeight, scaleWidth) {
            var defer = $q.defer();

            Upload.upload({
                url: SECURE_INIFEC_URL + "/MemberAction.do",
                withCredential: true,
                method: "POST",
                fields: {
                    op: "updateMemberPhoto",
                    cropX: cropX,
                    cropY: cropY,
                    cropWidth: cropWidth,
                    cropHeight: cropHeight,
                    scaleWidth: scaleWidth,
                },
                formDataAppender: function(fd, key, val) {
                    if (angular.isArray(val)) {
                        angular.forEach(val, function(v) {
                            fd.append(key, v);
                        });
                    } else {
                        fd.append(key, val);
                    }
                },
                file: file,
                withCredentials: true
            }).success(function(data) {
                if(data.error){

                    if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                        $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                    }
                    
                    defer.reject(data.error);
                }else{
                    defer.resolve(data);
                }                
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : UserFactory.updMemberPhoto request error.");
                console.error("status : " + status);
            });

            return defer.promise;
        }

        // --------------------------------
        // 取得會員的常用地址列表
        // --------------------------------
        var qyFavoriteAddress = function() {

            var defer = $q.defer();

            $http({
                url: SECURE_INIFEC_URL + "/MemberAction.do",
                method: "GET",
                params: {
                    op: "qyFavoriteAddress"
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {

                    if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                        $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                    }

                    defer.reject(data.error);
                } else {
                    defer.resolve(data);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : UserFactory.qyFavoriteAddress request error.");
                console.error("status : " + status);
            });

            return defer.promise;
        }

        // --------------------------------
        // 新增一筆常用地址
        // --------------------------------
        var addFavoriteAddress = function(name, phone, mobilephone, postal, address, remark, phoneExtension) {

            var defer = $q.defer();

            phone = removeDashInNumber(phone);
            mobilephone = removeDashInNumber(mobilephone);

            $http({
                url: SECURE_INIFEC_URL + "/MemberAction.do",
                method: "POST",
                data: $.param({
                    op: "addFavoriteAddress",
                    name: name,
                    phone: phone,
                    mobilephone: mobilephone,
                    postal: postal,
                    address: address,
                    remark: remark,
                    phoneExtension: phoneExtension,
                }),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {

                    if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                        $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                    }

                    defer.reject(data.error);
                } else {
                    defer.resolve(data);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : UserFactory.addFavoriteAddress request error.");
                console.error("status : " + status);
            });

            return defer.promise;
        }

        // --------------------------------
        // 修改某筆常用地址
        // --------------------------------
        var updateFavoriteAddress = function(name, phone, mobilephone, postal, address, remark, phoneExtension, index) {

            var defer = $q.defer();

            phone = removeDashInNumber(phone);
            mobilephone = removeDashInNumber(mobilephone);

            $http({
                url: SECURE_INIFEC_URL + "/MemberAction.do",
                method: "POST",
                data: $.param({
                    op: "updateFavoriteAddress",
                    name: name,
                    phone: phone,
                    mobilephone: mobilephone,
                    postal: postal,
                    address: address,
                    remark: remark,
                    phoneExtension: phoneExtension,
                    index: index,
                }),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {

                    if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                        $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                    }

                    defer.reject(data.error);
                } else {
                    defer.resolve(data);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : UserFactory.updateFavoriteAddress request error.");
                console.error("status : " + status);
            });

            return defer.promise;
        }

        // --------------------------------
        // 刪除某筆常用地址
        // --------------------------------
        var deleteFavoriteAddress = function(index) {

            var defer = $q.defer();

            $http({
                url: SECURE_INIFEC_URL + "/MemberAction.do",
                method: "POST",
                data: $.param({
                    op: "deleteFavoriteAddress",
                    index: index,
                }),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {

                    if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                        $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                    }

                    defer.reject(data.error);
                } else {
                    defer.resolve(data);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : UserFactory.deleteFavoriteAddress request error.");
                console.error("status : " + status);
            });

            return defer.promise;
        }

        // --------------------------------
        // 訂單完成時更新最後地址及常用地址清單
        // --------------------------------
        var updateContactInfo = function(addressInfo, senderInfo, isSaveAddress, isSaveSenderAddress) {

            var defer = $q.defer();

            $http({
                url: SECURE_INIFEC_URL + "/MemberAction.do",
                method: "POST",
                data: $.param({
                    op: "updateContactInfo",
                    addressInfo: addressInfo,
                    senderInfo: senderInfo,
                    isSaveAddress: isSaveAddress,
                    isSaveSenderAddress: isSaveSenderAddress
                }),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {
                    defer.reject(data.error);
                } else {
                    defer.resolve(data);

                    if(addressInfo) {
                        factory.user.contactInfo = JSON.parse(addressInfo);
                    }
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : UserFactory.updateContactInfo request error.");
                console.error("status : " + status);
            });

            return defer.promise;
        }

        // --------------------------------
        // 設定密碼（當密碼為空的時候
        // --------------------------------
        var setPassword = function(passwd) {

            var defer = $q.defer();

            $http({
                url:  SECURE_INIFEC_URL + "/MemberAction.do",
                method: "POST",
                data: $.param({
                    op: "setPassword",
                    passwd: passwd
                }),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {

                    if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                        $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                    }

                    defer.reject(data.error);
                } else {
                    defer.resolve(data);
                    factory.user.isNoPassword = false;
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : UserFactory.setPassword request error.");
                console.error("status : " + status);
            });

            return defer.promise;
        }

        // --------------------------------
        // 檢查手機是否可使用
        // --------------------------------
        var checkMobilephone = function(mobilephone) {

            var defer = $q.defer();

            $http({
                url: SECURE_INIFEC_URL + "/MemberAction.do",
                method: "GET",
                params: {
                    op: "checkMobilephone",
                    mobilephone: mobilephone
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {

                    if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                        $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                    }
                    
                    defer.reject(data.error);
                } else {
                    defer.resolve(data);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : UserFactory.checkMobilephone request error.");
                console.error("status : " + status);
            });

            return defer.promise;
        }

        // --------------------------------
        // 更新統一發票使用記錄
        // --------------------------------
        var updateLastInvoiceInfo = function(mrscid, company, invoice, invoiceType, 
            carrierType,digitalCitizenCarrierID, 
            mobilePhoneCarrierID, isDonate, loveCode) {

            var defer = $q.defer();

            $http({
                url:  SECURE_INIFEC_URL + "/MemberAction.do",
                method: "POST",
                data: $.param({
                    op: "updateLastInvoiceInfo",
                    mrscid: mrscid,
                    company: company, 
                    invoice: invoice,
                    invoiceType: invoiceType,
                    carrierType: carrierType,
                    digitalCitizenCarrierID: digitalCitizenCarrierID,
                    mobilePhoneCarrierID: mobilePhoneCarrierID,
                    donate: isDonate,
                    loveCode: loveCode,

                }),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {

                    if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                        $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                    }

                    defer.reject(data.error);
                } else {
                    defer.resolve(data);
                    
                    if(!factory.user.lastInvoiceInfo) {
                        factory.user.lastInvoiceInfo = [];
                    }

                    factory.user.lastInvoiceInfo.push({
                        invoiceTitle: company,
                        VATNumber: invoice,
                    });
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : UserFactory.updateLastInvoiceInfo request error.");
                console.error("status : " + status);
            });

            return defer.promise;
        }

        // --------------------------------
        // 更新使用者資訊（合併企業用戶）
        // --------------------------------
        var reloadInfoByBusinessMember = function() {

            $.extend(factory.user, BusinessMemberService.businessUser);
        }

        /*==========================
            Members
        ==========================*/
        factory.user = user; // 使用者資訊
        factory.hasLogin = hasLogin;

        /*==========================
            Methods
        ==========================*/
        /** 取得使用者資訊 */
        factory.getUserInfo = getUserInfo;
        /** 申請成為會員 */
        factory.applyAccount = applyAccount;
        /** Email 認證 */
        factory.identifyEmail = identifyEmail;
        /** 以EMail登入 */
        factory.loginWithEmail = loginWithEmail;
        /** 登出 */
        factory.logout = logout;
        /** 忘記密碼 */
        factory.forgetPassword = forgetPassword;
        /** 更新密碼 */
        factory.updPassword = updPassword;
        /** 重寄認證信 */
        factory.resendInvitaion = resendInvitaion;
        /** 更新使用者資訊 */
        factory.updateUserInfo = updateUserInfo;
        /** 修改使用者電子郵件 */
        factory.updateEmail = updateEmail;
        /** 設定新的電子郵件 */
        factory.changeEmail = changeEmail;
        /** 設定會員大頭照 */
        factory.updMemberPhoto = updMemberPhoto;
        /** 取得會員的常用地址列表 */
        factory.qyFavoriteAddress = qyFavoriteAddress;
        /** 新增一筆常用地址 */
        factory.addFavoriteAddress = addFavoriteAddress;
        /** 修改某筆常用地址 */
        factory.updateFavoriteAddress = updateFavoriteAddress;
        /** 刪除某筆常用地址 */
        factory.deleteFavoriteAddress = deleteFavoriteAddress;
        /** 修改會員最後使用的聯絡資訊 */
        factory.updateContactInfo = updateContactInfo;
        /** 会员载具归户**/
        factory.getJoinMemberCarrierParam = getJoinMemberCarrierParam;
        /** 設定密碼（當密碼為空的時候 */
        factory.setPassword = setPassword;
        /** 檢查手機是否可使用 */
        factory.checkMobilephone = checkMobilephone;
        // 更新統一發票使用記錄
        factory.updateLastInvoiceInfo = updateLastInvoiceInfo;
        // 更新使用者資訊（合併企業用戶）
        factory.reloadInfoByBusinessMember = reloadInfoByBusinessMember;

        /*==========================
            init
        ==========================*/

        /** 初始化，一進入就取得使用者資訊 */
        init();

        return factory;
    }
]);
